export const getChannelById = (channels, channelId) => {
    return channels.find((channel) => channel.code === channelId);
};
